import { useEffect, useRef } from "react";
import type QrScanner from "qr-scanner";

export function useQrScanner(onDecode: (text: string) => void, enabled: boolean) {
	const videoRef = useRef<HTMLVideoElement | null>(null);
	const lastRef = useRef<{ text: string; at: number }>({ text: "", at: 0 });

	useEffect(() => {
		if (!enabled || !videoRef.current) return;

		let scanner: QrScanner | null = null;
		let cancelled = false;

		void import("qr-scanner").then(({ default: QrScannerCtor }) => {
			if (cancelled || !videoRef.current) return;
			scanner = new QrScannerCtor(
				videoRef.current,
				(result) => {
					const now = Date.now();
					if (result.data === lastRef.current.text && now - lastRef.current.at < 2500) return;
					lastRef.current = { text: result.data, at: now };
					onDecode(result.data);
				},
				{ highlightScanRegion: true, maxScansPerSecond: 5 },
			);
			scanner.start().catch(() => undefined);
		});

		return () => {
			cancelled = true;
			scanner?.stop();
			scanner?.destroy();
		};
	}, [enabled, onDecode]);

	return videoRef;
}
